
/* @flow */
import React, { PropTypes } from 'react';
import Cog from '../../../components/svg/cog';
import Close from '../../../components/svg/close';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import { ConfirmModal } from 'components';
import * as variables from 'frilans-finans/variables';

export class InvoiceToolHeader extends React.Component {

  static propTypes = {
    openSettingsModal: PropTypes.func.isRequired,
    translationPrefix: PropTypes.string.isRequired
  };

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor (props, context) {
    super(props, context);

    this.state = {
      renderConfirmModal: false
    };

    this.onCloseClick = this.onCloseClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  onCloseClick () {
    this.setState({
      renderConfirmModal: true
    });
  }

  closeModal (confirm) {
    if (confirm) {
      this.context.router.replace('/activities');
    } else {
      this.setState({
        renderConfirmModal: false
      });
    }
  }

  renderConfirmModal () {
    if (this.state.renderConfirmModal) {
      return (
        <ConfirmModal callback={this.closeModal} message={proxyCounterpart('CONFIRM_CLOSE_TOOL')}/>
      );
    }
  }

  render () {
    return (
      <header className='page-header'>
        <div className='container'>
          <a href='#' className='account-link-mobile' onClick={this.props.openSettingsModal}>
            <Cog width='36' height='36' />
          </a>
          <a href={variables.frontUrl} className='logo center-logo' >
            <object type="image/svg+xml"
              data={require('images/logos/logo-white.svg')}
              alt='Frilans Finans-logotyp'>
              <img src={require('images/logos/logo-white.png')} alt="Frilans Finans-logotyp"/>
            </object>
          </a>
          <div className='right hide-tablet'>
            <a href='#'
              className='account-link'
              onClick={this.props.openSettingsModal}>
              <Translate content='ACCOUNT_SETTINGS'/>
            </a>
            <button className='btn outlined' onClick={this.onCloseClick}>
              <Translate content={this.props.translationPrefix + 'CLOSE_INVOICE_TOOL'}/>
            </button>
          </div>
          <button className='close-tool' onClick={this.onCloseClick}>
            <Close color="#FFFFFF" />
          </button>
        </div>
        {this.renderConfirmModal()}
      </header>
    );
  }

}

export default InvoiceToolHeader;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/header/invoice-tool-header.js
 **/